import React, { Component } from 'react';
import ShopQueueDMK from './queue_dmk';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import EtaContainerDmk from '../../assets/dmk-eta-container.png';


const Shop = styled.div`
    flex: 1;
    border: 2px solid #808080;
    padding-left: 35px;
    flex-direction: row;
    font-size: 52px;
    font-weight: 600;
    letter-spacing: 3.2px;
    color: rgba(0, 0, 0, 0.87);
    min-width: 47.5%;
    max-width: 47.5%;
    font-family: "GraphikSemiBold";
    display: flex;
    &:nth-child(even) {
        border-right: 0;
        border-left: 0;
        border-bottom: 0;
    };
    &:nth-child(odd) {
        border-left: 0;
        border-bottom: 0;
    };
    &:first-child {
        border-top: 0;
    }
    &:nth-child(2) {
        border-top: 0;
    }
`
const ShopInnerContainer = styled.div`
    flex: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const EtaContainer = styled.div`
    flex: 1;
    flex-direction: column;
    align-self: center;
    position: relative;
`

const EtaImage = styled.img`
    margin-left: auto;
    margin-right: auto;
    width: 143px;
    height: 143px;
    display: block;
`

const EtaText = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: "GraphikSemiBold";
    font-size: 62px;
    font-weight: 600;
    letter-spacing: 3.84px;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
`

const MinText = styled.div`
    width: 35px;
    height: 16px;
    font-family: "GraphikSemiBold";
    font-size: 21px;
    font-weight: 500;
    letter-spacing: 1.28px;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
`

const ShopTitle = styled.div`
  font-family: "GraphikSemiBold";
  font-size: 41px;
  font-weight: 600;
  letter-spacing: 2.56px;
  color: #808080;
  margin-top: 11px;
`

@observer
export default class ShopListItemDMK extends Component {
  render() {
    const {name, id, queueLength, title, eta} = this.props;
    if (!name) return <Shop/>
    return(
      <Shop key={id}>
          <ShopInnerContainer>
              {name.toUpperCase()}
              {!!title && <ShopTitle>{title.toUpperCase()}</ShopTitle>}
              <ShopQueueDMK queueLength={queueLength}/>
          </ShopInnerContainer>
          <EtaContainer>
              <EtaImage src={EtaContainerDmk}/>
              <EtaText>
                  {eta}
                  <MinText>MIN</MinText>
              </EtaText>
          </EtaContainer>
      </Shop>
  )}
}



// WEBPACK FOOTER //
// ./src/components/food_court_shop_list_panel/shop_list_item_dmk.jsx